'use strict';

var processInclude = require('theme/js/util');

$(document).ready(function () {
    processInclude(require('theme/js/login/login'));
    // processInclude(require('theme/js/product/quickView'));
});
